export default __webpack_public_path__ + "static/media/screen.606b513e.png";